// extracted by mini-css-extract-plugin
module.exports = {"contentWrapper":"_1qH4Y","backgroundWrapper":"_1x1Fm","banner":"_2q17D","content":"_3LvkY","formContainer":"XGkiS","formWrapper":"_1FEdS","contentList":"_2FpLq"};